import {React, useContext, useMemo, Link, useLocation} from 'external/react'
import {styled, clsx, TableCell, TableRow, TableBody} from 'external/material'
import {dayjs} from 'external/dayjs'

import {TeacherContext} from 'teacher/context'
import GradeCell from './GradeCell'

const StyledTableBody = styled(TableBody)(gradeBodyStyles)

export default function GradesBody(props) {

  const context = useContext(TeacherContext)

  const {rows, columns} = props
  const {query, link, groupId} = context
  const {gradeFilter: queryGradeFilters} = query
  const location = useLocation()
  
  const handleStudentLinkClick = () => {
    context.updateState({rollbookContextStudentGradesNavigation: {
        origin: {$set: location.pathname},
        query: {$set: query}
      }
    })
  }

  const filterGrades = (column) => {
    const queryFiltersValue = queryGradeFilters ?? []
    const queryFilters = Array.isArray(queryFiltersValue) ? queryFiltersValue : [queryFiltersValue]

    if(queryFilters.includes('all') || queryFilters.length === 0){
      return true
    }

    const dateAssigned = dayjs(new Date(column.date))
    const creationDate = dayjs(new Date(column.start))

    if (queryFilters.includes(column.type)) {
      return true;
    }

    const isManual = dateAssigned.isAfter(creationDate);
    const isAdjust = dateAssigned.isBefore(creationDate); 

    if (isManual && queryFilters.includes('manual')) {
      return true;
    }

    if (isAdjust && queryFilters.includes('adjust')) {
      return true;
    }

    return false

  }
  
  const studentLink = useMemo(
    () => student => link({page: 'gradebook', groupId, studentId: student.id}),
    [groupId, link]
  )
  return (
    <StyledTableBody>
      {rows.map(student => {
        return (
         <TableRow key={student.id} className="row">  
           <TableCell align="left" className="cell">
              <Link to={studentLink(student)} onClick={handleStudentLinkClick} className="studentLink">{student.name}</Link>
           </TableCell>
           <TableCell align="center" className={clsx("cell", 'summary')}>
              {student.summary}%
           </TableCell>
            {student.columns.filter(filterGrades).map((column, index) => {
              const dateAssigned = dayjs(new Date(column.date))
              const creationDate = dayjs(new Date(column.start))
              const isExternal = Boolean(column?.external)
              const classNameDate = dateAssigned.isBefore(creationDate) ? 'gradeLabelPastDate' : 'gradeLabelPresentDate'
              return (<GradeCell key={index} classname={`${isExternal ? classNameDate : ''}`} student={student} column={column} />)
            })}
           <TableCell className="filler" style={{top:92}} align="right"></TableCell>
         </TableRow>
        )}
      )}
    </StyledTableBody>
  )
}

function gradeBodyStyles() {
  return {
    "& .cell": {
      padding: 0,
      color: '#4f576e',
      height: 60,
      fontWeight: 500,
      borderLeft: 'solid 1px #d8dbe0',
      borderRight: 'solid 1px #d8dbe0',
      '&:first-of-type': {
        borderLeft: 0,
        paddingLeft: 12,
      },
      '&.summary': {
        backgroundColor:'#f5fff6'
      }
    },
    "& .studentLink": {
      color: '#4f576e',
      fontWeight: 'bold',
      textDecoration: 'none'
    },
    "& .gradeLabelPastDate": {
      backgroundColor: 'rgba(234, 185, 237, 0.2)'
    },
    "& .gradeLabelPresentDate": {
      backgroundColor: 'rgba(205, 240, 192, 0.2)'
    },
  }
}
